import { render, staticRenderFns } from "./OurMembers.vue?vue&type=template&id=74a7dc50&scoped=true"
import script from "./OurMembers.vue?vue&type=script&lang=js"
export * from "./OurMembers.vue?vue&type=script&lang=js"
import style0 from "./OurMembers.vue?vue&type=style&index=0&id=74a7dc50&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a7dc50",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/Users/afonsomonteiro/onboarding/onboarding/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74a7dc50')) {
      api.createRecord('74a7dc50', component.options)
    } else {
      api.reload('74a7dc50', component.options)
    }
    module.hot.accept("./OurMembers.vue?vue&type=template&id=74a7dc50&scoped=true", function () {
      api.rerender('74a7dc50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/lp/OurMembers.vue"
export default component.exports